<template>
  <div class="footer-container">
    <div class="footer-item" @click="goPage('/')">
      <img :src="`${require('@assets/images/dywfl/index1-1.png')}`" alt="" v-if="index1">
      <img :src="`${require('@assets/images/dywfl/index1-0.png')}`" alt="" v-else>
      <div class="footer-title">首页</div>
    </div>
	<div class="footer-item" @click="goPage('/help/index')">
	  <img :src="`${require('@assets/images/dywfl/index3-1.png')}`" alt="" v-if="index2">
	  <img :src="`${require('@assets/images/dywfl/index3-0.png')}`" alt="" v-else>
	  <div class="footer-title">爱心妈妈</div>
	</div>
	<div class="footer-item" @click="goPage('/hope/index')">
	  <img :src="`${require('@assets/images/dywfl/hb1-1.png')}`" alt="" v-if="index3">
	  <img :src="`${require('@assets/images/dywfl/hb1-0.png')}`" alt="" v-else>
	  <div class="footer-title">微心愿</div>
	</div>
    <div class="footer-item" @click="goPage('/social/serve')">
      <img :src="`${require('@assets/images/dywfl/index2-1.png')}`" alt="" v-if="index4">
      <img :src="`${require('@assets/images/dywfl/index2-0.png')}`" alt="" v-else >
      <div class="footer-title">社会服务</div>
    </div>
  </div>
</template>
<script>
import {getNavCate} from "@/api/public.js"
export default {
  name: "Footer",
  props: {},
  inject:['app'],
  data: function() {
    return {
      index1:false,
      index2:false,
      index3:false,
      index4:false,
    };
  },
  created(){
	if(this.$route.path=='/'){
		this.index1=true;
	}
	if(this.$route.path=='/help/index'){
		this.index2=true;
	}
	if(this.$route.path=='/hope/index'){
		this.index3=true;
	}
	if(this.$route.path=='/social/serve'){
		this.index4=true;
	}
	if (this.$route.path=='/') {
		this.index1=true;
	} else if (this.$route.path=='/help/index') {
		this.index2=true;
	} else if (this.$route.path=='/hope/index') {
		this.index3=true;
	} else if (this.$route.path=='/social/serve') {
		this.index4=true;
	} else {
		this.index1=true;
	}
  },
  mounted(){
  },
  methods: {
    goPage(url) {
      this.$router.push({ path: url });
    }
  }
};
</script>
<style scoped lang="scss">
  .footer-container{
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: #fff;
    box-shadow: -1px -1px .2rem 0rpx rgba(6,0,1,0.08);
    width: 100%;
    display: flex;
    .footer-item{
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img{
        width: .5rem;
        height: .45rem;
        object-fit: contain;
      }
    }
  }
</style>
